module.exports = __webpack_public_path__ + "static/media/moonDragon.b60a0d60.jpg";